"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _FileCopyOutlined = _interopRequireDefault(require("@material-ui/icons/FileCopyOutlined"));
var _ReadMoreText = _interopRequireDefault(require("../ReadMoreText"));
var _Auth = require("../../contexts/Auth");
var _styles = _interopRequireDefault(require("./styles"));
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
var _Copy = require("../../constants/Copy");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var CopyDiv = props => {
  var {
    title,
    reference,
    abntProp,
    onCopy,
    referencePage,
    editionYear,
    author,
    origin
  } = props;
  var classes = (0, _styles.default)();
  var matches = (0, _core.useMediaQuery)('(min-width:769px)');
  var [snackBar, setSnackBar] = (0, _react.useState)(false);
  var {
    auth
  } = (0, _Auth.useAuth)();
  var trackService = (0, _Trackings.default)(auth);
  var getAbntContent = () => {
    if (!abntProp) return '';
    return "(".concat(author || 'author', " ").concat(editionYear, ", p.").concat(referencePage, ")");
  };
  var getReference = () => abntProp ? "'".concat(reference, "' ").concat(getAbntContent()) : reference;
  var trackingTextCopy = () => {
    trackService.trackCopyText({
      bookPage: referencePage,
      copyText: getReference(),
      copyType: abntProp ? _Copy.TYPE.ABNT_TEXT : _Copy.TYPE.PLAIN_TEXT,
      copyOrigin: origin
    });
  };
  var copyToClipBoard = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* () {
      trackingTextCopy();
      var value = getReference();
      setSnackBar(true);
      navigator.clipboard.writeText(value);
      setTimeout(() => {
        setSnackBar(false);
      }, 5000);
      yield onCopy(value);
    });
    return function copyToClipBoard() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    onContextMenu: e => e.preventDefault(),
    className: abntProp && classes.copyDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.top
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: matches ? classes.title : classes.titleMobile
  }, title), /*#__PURE__*/_react.default.createElement(_saraivaUi.Button, {
    color: "secondary",
    onClick: copyToClipBoard,
    startIcon: /*#__PURE__*/_react.default.createElement(_FileCopyOutlined.default, {
      style: {
        margin: 0
      }
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.copyBtnLabel
  }, matches ? 'Copiar' : ''))), /*#__PURE__*/_react.default.createElement(_ReadMoreText.default, {
    textClassName: matches ? classes.reference : classes.referenceMobile,
    detailText: getAbntContent(),
    text: getReference(),
    lines: 3
  })), snackBar && /*#__PURE__*/_react.default.createElement("div", {
    className: matches ? classes.snackBar : classes.snackBarMobile
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.Snackbar, {
    severity: "success",
    noClose: true,
    show: snackBar
  }, abntProp ? 'Citação direta copiada para a área de transferência.' : 'Trecho copiado para área de transferência.')));
};
CopyDiv.propTypes = {
  title: _propTypes.default.string.isRequired,
  reference: _propTypes.default.string.isRequired,
  abntProp: _propTypes.default.bool,
  onCopy: _propTypes.default.func.isRequired
};
CopyDiv.defaultProps = {
  abntProp: false
};
var _default = exports.default = CopyDiv;